import './WorkHours.scss';
import { daysOrder, getCapitalizeWord, getLocalTimeString, useTranslation } from '../../utils';
import type { TDaySchedule } from '../../utils/types';
import { fullDataAtom } from '../../atoms';
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

const WorkHours = () => {
  const fullExpertData = useRecoilValue(fullDataAtom);
  const { t } = useTranslation();

  const workHoursData: (TDaySchedule & { day: string })[] = useMemo(() => {
    const schedule = fullExpertData?.workHours?.schedule;

    if (!schedule) return [];

    const workHoursArray: (TDaySchedule & { day: string })[] = [];

    for (const [key, value] of Object.entries(schedule)) {
      workHoursArray.push({ ...value, day: key });
    }

    return workHoursArray
      .filter((day) => day.enabled)
      .sort((a, b) => {
        return (
          daysOrder[a.day as keyof typeof daysOrder] -
          daysOrder[b.day as keyof typeof daysOrder]
        );
      });
  }, [fullExpertData]);

  if (!fullExpertData) return <></>;

  if (workHoursData.length === 0) {
    return (
      <div className='scheduleContainer'>
        <h3 className='title'>
          <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
            <circle cx='12' cy='12' r='9' />
            <path d='M12 7v5l3 3' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
          {t('Settings (expert).Tab_workhours')}
        </h3>
        <p>{t('Expert.No_workhours')}</p>
      </div>
    );
  }

  return (
    <div className='scheduleContainer'>
      <h3 className='title'>
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
          <circle cx='12' cy='12' r='9' />
          <path d='M12 7v5l3 3' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
        {t('Settings (expert).Tab_workhours')}
      </h3>
      <div className='dayList'>
        {workHoursData.map((schedule, i) => {
          return (
            <div className='scheduleItem' key={i}>
              <span className='scheduleDay'>
                {getCapitalizeWord(t(`Days.${getCapitalizeWord(schedule.day)}`))}
              </span>
              <div className='scheduleTimes'>
                {schedule.ranges.map((range, j) => (
                  <span key={j} className='scheduleTime'>
                    {getLocalTimeString(range.starts)}-{getLocalTimeString(range.ends)}
                  </span>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WorkHours;
